import React, { lazy, Suspense, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';

// Lazy load components
const HomePage = lazy(() => import('./pages/HomePage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ServicesPage = lazy(() => import('./pages/ServicesPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const VerticalsPage = lazy(() => import('./pages/VerticalsPage'));
const GovernmentVerticalPage = lazy(() => import('./pages/verticals/GovernmentVerticalPage'));
const DefenceVerticalPage = lazy(() => import('./pages/verticals/DefenceVerticalPage'));
const BFSIVerticalPage = lazy(() => import('./pages/verticals/BFSIVerticalPage'));
const DigitalNativeVerticalPage = lazy(() => import('./pages/verticals/DigitalNativeVerticalPage'));
const LoginPage = lazy(() => import('./pages/Login'));
const DashboardPage = lazy(() => import('./pages/Dashboard'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

// Layout components
const Layout = lazy(() => import('./components/layout/Layout'));
const LoadingSpinner = lazy(() => import('./components/ui/LoadingSpinner'));

const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-dark-900">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Suspense fallback={
            <div className="min-h-screen flex items-center justify-center bg-dark-900">
              <LoadingSpinner size="lg" />
            </div>
          }>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<HomePage />} />
                <Route path="about" element={<AboutPage />} />
                <Route path="services" element={<ServicesPage />} />
                <Route path="contact" element={<ContactPage />} />
                <Route path="verticals" element={<VerticalsPage />} />
                <Route path="login" element={<LoginPage />} />
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="verticals/government" element={<GovernmentVerticalPage />} />
                <Route path="verticals/defence" element={<DefenceVerticalPage />} />
                <Route path="verticals/bfsi" element={<BFSIVerticalPage />} />
                <Route path="verticals/digital-native" element={<DigitalNativeVerticalPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Routes>
          </Suspense>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
